import {GameType} from './game-type';

export class Game {
	id: number;
	name: string;
	type: GameType;
}



// WEBPACK FOOTER //
// ./src/app/classes/game.ts